var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "136 -824 688 688",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250.85-269.62q54-35.69 109.73-53.03Q416.31-340 480-340t119.42 17.35q55.73 17.34 109.73 53.03 39.62-41 61.23-94.84Q792-418.31 792-480q0-129.67-91.23-220.84-91.23-91.16-221-91.16T259-700.84Q168-609.67 168-480q0 61.69 21.62 115.54 21.61 53.84 61.23 94.84M480.02-428q-51.56 0-87.79-36.21T356-551.98t36.21-87.79T479.98-676t87.79 36.21T604-552.02t-36.21 87.79T480.02-428m.26 292q-71.59 0-134.28-26.54t-109.81-73.65q-47.11-47.12-73.65-109.77T136-480.46t26.54-134.04 73.65-109.31q47.12-47.11 109.77-73.65T480.46-824t134.04 26.54 109.31 73.65q47.11 47.12 73.65 109.53 26.54 62.42 26.54 134 0 71.59-26.54 134.28t-73.65 109.81q-47.12 47.11-109.53 73.65-62.42 26.54-134 26.54m-.28-32q54.31 0 108.85-20.35 54.53-20.34 96.53-56.96-43-29.31-95.23-46T480-308t-111.04 15.81q-53.11 15.81-94.34 46.88 42 36.62 96.53 56.96Q425.69-168 480-168m0-292q37.69 0 64.85-27.15Q572-514.31 572-552t-27.15-64.85Q517.69-644 480-644t-64.85 27.15Q388-589.69 388-552t27.15 64.85Q442.31-460 480-460m0 217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.c0b35b1fb23b484b336799d2d2058b62.svg";
export { ForwardRef as ReactComponent };